import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import originFields from '../../defaults/PointOfOriginFields.json';
import { connect } from 'react-redux';
import theme from '../../muiTheme';
const styles = {
    errorDialogContent: {
        width: "500px"
    },
    errorDialogTitle: {
        color: theme.palette.accent1Color
    }
};

class PrescibedEscapeDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            wfUFI: null
        };
    }

    onUpdateProp = (value) => {
        this.setState({
            wfUFI: value
        });
    }

    onAssociateWF = () => {
        window.api.createPrescibedEscape(this.state.wfUFI, this.props.incident.attributes[originFields.fireOccurenceRecordID]).then(response => {
            this.props.onCloseEscapeDialog();
            
            /*const unitIdIsValid = (unitIdResponse && unitIdResponse.units && unitIdResponse.units.length > 0);
            const unitIdString = (unitIdIsValid) ? unitIdResponse.units[0].NAME : this.state.attributes[originFields.pooProtectingUnit] + " is not a valid unit";
      
            this.setState({
              isQueryingUnitId: false,
              showUnitIdWarning: true,
              unitIdIsValid: unitIdIsValid,
              unitIdString: unitIdString
            }); */
          });
    }


    render() {

        return (
            <Dialog
                title="Associate a Prescribed Escape"
                modal={true}
                titleStyle={styles.errorDialogTitle}
                open={this.props.open}
                fullScreen
                autoScrollBodyContent={true}>
                <Paper elevation={3}>

                    <Table>
                        <TableBody>
                            <TableRow className="incident-attribute">
                                <TableCell className="incident-attribute-cell">
                                    Wildlfire Unique Fire Idenfier
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        id="wfUFI"
                                        style={{ width: "250px" }}
                                        className="newincident-latlong-textField"
                                        onChange={(event) => {
                                            this.onUpdateProp(event.target.value);
                                        }}
                                        margin="dense"
                                        required
                                        variant="outlined"
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    <DialogActions>
                        <Button onClick={this.onAssociateWF} disabled={!this.state.wfUFI}>Associate Wildfire as Prescribed Escape</Button>
                        <Button onClick={this.props.onCloseEscapeDialog} color="primary">
                            Close
                        </Button>

                    </DialogActions>
                </Paper>
            </Dialog>
        )
    }
}

const mapStateToProps = state => ({
    appConfig: state.config
})

export default connect(mapStateToProps)(PrescibedEscapeDialog)
